<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-10-09 10:19:22
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-22 17:16:43
 * @FilePath: \合联\oms\src\view\analysis\gccOrderStatistics\order.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    isTabs
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/analysis/financialRevenue";
export default {
  name: "",
  components: {
    cTable
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    headers: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  mounted() {
    console.log(apis);
    this.header.searchs.splice(
      0,
      0,
      ...this.headers.filter(t => {
        if (t.includes) {
          return t.includes.includes(this.name);
        } else return true;
      })
    );
  },
  data() {
    return {
      methods: {
        ...apis,
        list: p => {
          return this.data.list(p);
        },
        beforeHandleList: ({ data, list }) => {
          return data;
        }
      },
      config: {
        tabHeight: -30,
        slot: "div",
        isGetList: true
      },
      footer: {
        show: () => false
      },
      modals: {},
      header: {
        searchs: [],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary"
              }
            }
            // {
            //   name: () => this.$tz("详情,导出"),
            //   type: "detail",
            //   fnName: "detail",
            //   bind: {
            //     type: "primary"
            //   }
            // }
          ],
          methods: {
            import() {
              this.getModal("upload").open({}, function() {
                this.setTitle(this.$tz("导入"));
              });
            },
            export: () => {
              let table = this.$refs["table"];
              table.selectAll = table.list;
              table.exportExc(this.$t(this.$route.name) + "-" + this.name);
            },
            detail({ searchForm }) {
              this.handleRequestMethods(
                "list",
                Object.assign({ export: 1 }, searchForm),
                false,
                true
              ).then(res => {
                this.$Message.success(res.msg);
              });
            }
          }
        }
      },
      fields: [
        {
          name: () => this.$tz("客服"),
          key: "service",
          minWidth: 130,
          show:()=>this.name === 'service'
        },
        {
          name: () => this.$tz("仓库"),
          key: "agent",
          minWidth: 130,
          show:()=>this.name === 'delivery  '
        },
        {
          name: () => this.$tz('出派异常及时率(48小时内)'),
          children: [
            {
              name: () => this.$tz("统计,订单"),
              key: "delivery_num",
              minWidth: 130
            },
            {
              name: () => this.$tz("达标订单"),
              key: "delivery_suc_num",
              minWidth: 130
            },
            {
              name: () => this.$tz("及时率"),
              key: "delivery_rate",
              minWidth: 130
            },
          ],
        },
        {
          name: () => this.$tz('异常退件及时率 RTOO~WTW(7天内)'),
          children: [
            {
              name: () => this.$tz("统计订单"),
              key: "return_num",
              minWidth: 130
            },
            {
              name: () => this.$tz("达标订单"),
              key: "return_suc_num",
              minWidth: 130
            },
            {
              name: () => this.$tz("及时率"),
              key: "return_rate",
              minWidth: 130
            }
          ],
        },
      ]
    };
  }
};
</script>

<style scoped></style>
